import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken, TOKEN_PERSIST_ERROR } from '@/utils/auth'
import { pickLoginUserFields } from '@/utils/loginUserInfo'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead+data.token
          localStorage.setItem("loginUserInfo", JSON.stringify(pickLoginUserFields(data.user)));
          // cookie 最后写：它是“会话存在”的唯一凭据，前面任何一步抛异常都必须让
          // cookie 压根不存在，否则会留下一个“UI 说没登录、实际有效 7 天”的孤儿会话。
          if (!setToken(tokenStr)) {
            // 已经写下去的 loginUserInfo 要撤掉，别让它带着上一个用户的资料留在这
            try { localStorage.removeItem("loginUserInfo") } catch (e) {}
            reject(new Error(TOKEN_PERSIST_ERROR))
            return
          }
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          // removeToken 失败说明 cookie 还在、会话仍然是活的（后端 logout 是空实现，
          // JWT 不会失效）。这时候清掉内存里的 token/roles 再 resolve 等于告诉用户
          // “已退出”，但浏览器里其实还登着。不清状态、reject，让调用方把用户留在
          // 原地——那才是真的；错误提示已经由 removeToken 自己的 Message.error 弹过了。
          if (!removeToken()) {
            reject('removeToken failed')
            return
          }
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    // 这里永远 resolve、永远不 reject：调用方包含路由守卫的恢复路径和 401
    // 拦截器，它们靠 .then() 继续走 next() / 跳转，一旦 reject 就是导航卡死，
    // 比“cookie 没删干净”严重得多。所以连异常也要吞——但要把清理到底成没成
    // 通过 resolve 的参数传出去，让主动登出的调用方（移动端“退出”按钮）能
    // 据此决定要不要跳转。
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        let removed = false
        try {
          commit('SET_TOKEN', '')
          removed = removeToken()
        } catch (e) {
          console.error('[auth] FedLogOut 清理 token 时抛异常', e)
        }
        resolve(removed)
      })
    }
  }
}

export default user
